var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11407_18951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4358 20C16.31 20 14.1516 19.4914 11.9607 18.4741C9.76988 17.4569 7.74236 16.0162 5.87818 14.152C4.00394 12.2778 2.55569 10.2427 1.53341 8.0468C0.511137 5.8509 0 3.69507 0 1.5793C0 1.14033 0.150965 0.767378 0.452895 0.460427C0.754807 0.153476 1.12524 0 1.56421 0H5.30339C5.72376 0 6.07078 0.121737 6.34446 0.365211C6.61813 0.608686 6.80567 0.944481 6.90707 1.3726L7.6282 4.49631C7.68395 4.86637 7.67446 5.19655 7.59975 5.48685C7.52504 5.77717 7.3762 6.02374 7.15324 6.22656L4.42201 8.83355C4.8447 9.53648 5.29409 10.1961 5.7702 10.8123C6.2463 11.4285 6.78086 12.0192 7.37388 12.5843C7.99243 13.2307 8.62897 13.8067 9.28351 14.3122C9.93806 14.8178 10.6156 15.254 11.3163 15.6209L13.929 12.9582C14.1776 12.6919 14.4578 12.5131 14.7698 12.4217C15.0818 12.3304 15.4088 12.3226 15.751 12.3985L18.6274 13.0476C19.0555 13.1692 19.3913 13.377 19.6348 13.6712C19.8783 13.9654 20 14.3215 20 14.7396V18.4358C20 18.8748 19.8465 19.2452 19.5396 19.5471C19.2326 19.849 18.8647 20 18.4358 20Z",
    fill: "#BEAEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11407_18951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.047d872bcc8b01b16007ff4b81b1989a.svg";